import { t } from "../locale";

/**
 * @param {Fencealarm2} fa2
 * @returns {string}
 */
function checkVoltageLevel(fa2) {
	if (!fa2.VoltageAlarm.Enabled) return "";
	if (!fa2.VoltageAlarm.Triggered) return "";
	return t.fencealarm.card.lowVoltageWarning;
}

/**
 * @param {Fencealarm2} fa2
 * @returns {string[]}
 */
function getFencealarm2Warnings(fa2) {
	return [checkVoltageLevel(fa2)].filter((text) => text !== "");
}

export { getFencealarm2Warnings };
